module.exports = "/*!\n * jQuery UI Draggable 1.13.3\n * https://jqueryui.com\n *\n * Copyright OpenJS Foundation and other contributors\n * Released under the MIT license.\n * https://jquery.org/license\n */\n.ui-draggable-handle {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui/themes/base/draggable.css
// module id = 463
// module chunks = 0